import { createElementBlock as e, openBlock as l, createElementVNode as t } from "vue";
const s = {
  width: "83",
  height: "82",
  viewBox: "0 0 83 82",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__call-to-action-find"
};
function o(n, L) {
  return l(), e("svg", s, L[0] || (L[0] = [
    t("path", {
      d: "M41.5 1L69.7843 12.7157L81.5 41L69.7843 69.2843L41.5 81L13.2158 69.2843L1.5 41L13.2158 12.7157L41.5 1Z",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    t("path", {
      d: "M41.5001 7L65.5418 16.9584L75.5002 41.0001M41.5001 75.0002L17.4584 65.0418L7.5 41.0001",
      stroke: "#00E0E0",
      "stroke-width": "2",
      class: "svg__stroke--help-green-03"
    }, null, -1),
    t("path", {
      d: "M47.5815 45.8775L47.0512 45.3471L45.9905 46.4077L46.5208 46.9381L47.5815 45.8775ZM54.0684 54.4868L54.5987 55.0171L55.6594 53.9566L55.1291 53.4262L54.0684 54.4868ZM43.8308 49.4704C49.8651 46.9058 52.678 39.9351 50.1134 33.9007L48.7329 34.4874C50.9734 39.7593 48.516 45.8494 43.2441 48.0899L43.8308 49.4704ZM50.1134 33.9007C47.5489 27.8664 40.5781 25.0536 34.5438 27.6181L35.1305 28.9986C40.4024 26.7581 46.4924 29.2155 48.7329 34.4874L50.1134 33.9007ZM34.5438 27.6181C28.5095 30.1826 25.6966 37.1534 28.2612 43.1877L29.6417 42.601C27.4011 37.3291 29.8586 31.2391 35.1305 28.9986L34.5438 27.6181ZM28.2612 43.1877C30.8257 49.2221 37.7965 52.0349 43.8308 49.4704L43.2441 48.0899C37.9722 50.3304 31.8822 47.8729 29.6417 42.601L28.2612 43.1877ZM46.5208 46.9381L54.0684 54.4868L55.1291 53.4262L47.5815 45.8775L46.5208 46.9381Z",
      fill: "#0AA5FF",
      class: "svg__fill--default-cyan-03"
    }, null, -1)
  ]));
}
const a = { render: o };
export {
  a as default,
  o as render
};
